module.exports = __webpack_public_path__ + "1f18b0df7bafb6a644fa864158b4625d.svg";